import { useContextSelector as useCS } from 'use-context-selector';
import { useRequest } from 'domain/core/hooks/useRequest';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { TUpdate } from 'domain/types';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useForgotPassword = (): any => {
  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const {
    isLoading,
    error,
    status,
    send: requestSend,
  } = useRequest({
    url: '/api/v1/auth/forgot/password',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const send = (body: { email: string }) => {
    if (update && body.email) {
      update({ currentEmail: body.email });
      requestSend({ ...body }).then();
    }
  };

  return {
    isLoading,
    error: error ? { message: error?.response?.data?.errors?.email } : null,
    send,
    status,
  };
};
